
















































import {
  defineComponent,
  ref,
  computed,
} from '@vue/composition-api';
import { Popup } from '@hb/coffee';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';

import lightSymbolImage from './images/light-symbol@3x.png';
import safeSymbolImage from './images/safe-symbol@3x.png';

export default defineComponent({
  components: {
    Popup,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['confirm', 'cancel'],
  setup(props, context) {
    const closeablePopup = ref(false);
    const onConfirm = () => {
      context.emit('confirm');

      ubtSetupPageButton('finance_loan_apply_switchPopUp', {
        content: '好的',
        actionType: 'confirm',
      });
    };

    const onCancel = () => {
      context.emit('cancel');

      ubtSetupPageButton('finance_loan_apply_switchPopUp', {
        content: '仍要切换',
        actionType: 'cancel',
      });
    };

    return {
      closeablePopup,
      onConfirm,
      onCancel,
      lightSymbolImage,
      safeSymbolImage,
      open: () => {
        /** do nothing */
      },
      close: () => {
        /** 用户从退出键触发关闭弹窗时，不切换选择渠道 */
        context.emit('confirm');
      },
      isOpen: computed(() => props.visible),
    };
  },
});
